import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
//  Interface for Data table data type for all the columns
export interface Props {
  children?: FC;
  item?: AccountEventName;
}

interface AccountEventName {
  PO?: string;
  poWarning?: string;
}
const OrderPOCell: FC<Props> = ({
  item = {
    PO: '',
    poWarning: '',
  },
}) => {
  const { PO, poWarning } = item;
  return (
    <DataTableCell title={PO || ''}>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{PO}</p>
      {!!poWarning && (
        <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: '2px' }}>
          {poWarning}
        </p>
      )}
    </DataTableCell>
  );
};

/** Custom Account/Event Name cell */
export default OrderPOCell;
